var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.656 68.067"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21",
    d: "M23.797 68.067c-1.44-1.735-2.852-3.386-4.209-5.08A130.02 130.02 0 015.761 42.4 56.176 56.176 0 01.642 29.259 23.845 23.845 0 0119.656.35a23.82 23.82 0 0127.562 18.83 26.379 26.379 0 01-1.171 13.63 77.937 77.937 0 01-9 17.842 152.01 152.01 0 01-12.814 16.95c-.101.119-.214.231-.436.465zm.109-52.736a8.424 8.424 0 00-8.535 8.436 8.43 8.43 0 008.556 8.5 8.429 8.429 0 008.374-8.438 8.42 8.42 0 00-8.395-8.497z"
  }))));
}

export default __webpack_public_path__ + "6d653077d44aa1f90088cb9110657f8c.svg";
export { SvgMap as ReactComponent };